export const TableHelper = {
  methods: {
    addStickyColumnByKeys(fields, keys) {
      fields.forEach((n, i) => {
        if (keys.includes(n.key)) {
          fields[i] = {
            ...fields[i],
            thAttr: {
              style: 'position:sticky;min-width:180px;max-width:180px;z-index:1;',
            },
            tdAttr: {
              style: 'position:sticky;min-width:180px;max-width:180px;z-index:1;',
            },
          }
        }
      })

      return fields
    },
    applyStickyColumnToPrev(fields, firstIgnoredColumn = 1, maxColumn = 5) {
      // freezing column
      // - find "last index with sticky in its tdAttr->style" but not the last index
      // - if it bellow maximum sticky setting:
      //    - then apply sticky to all field before lastIndex
      const hasStickyStyle = (f) =>
        f.tdAttr?.style.toLowerCase().includes('sticky') ||
        f.thAttr?.style.toLowerCase().includes('sticky')

      const getWidthStyle = (f) =>
        f.tdAttr?.style.toLowerCase().match(/min-width:([\d.]+)px/)?.[1] ||
        f.thAttr?.style.toLowerCase().match(/max-width:([\d.]+)px/)?.[1] ||
        180

      // iterasi dari index sebelum akhir
      let lastStickyIndex = -1
      for (let index = firstIgnoredColumn; index < fields.length - 1; index += 1) {
        const hasSticky = hasStickyStyle(fields[index])
        if (hasSticky) {
          lastStickyIndex = index
        }
      }

      // treshold max sticky
      if (lastStickyIndex < maxColumn + firstIgnoredColumn) {
        // 49.5 for checkbox
        let leftSize = 49.5 * firstIgnoredColumn
        for (let indexN = firstIgnoredColumn; indexN <= lastStickyIndex; indexN += 1) {
          const width = parseFloat(getWidthStyle(fields[indexN]))
          fields[indexN] = {
            ...fields[indexN],
            tdAttr: {
              style: `width:${width}px;min-width:${width}px;left:${leftSize}px;position:sticky;z-index:1;`,
            },
            thAttr: {
              style: `width:${width}px;min-width:${width}px;left:${leftSize}px;position:sticky;z-index:1;`,
            },
          }
          // add +1 for border
          leftSize += width + 1
        }
      }

      return fields
    },
  },
}
